import { gql } from '@apollo/client';

export const GET_AGENT_CONFIGURATIONS_LIST = gql`
  query AgentConfigurations($params: FindAgentConfigurationListInput!) {
    agentConfigurations(params: $params) {
      success
      message
      errors
      data {
        agents {
          id
          agentKey
          provider
          modelName
          temperature
          maxTokens
          maxOutputTokens
          maxRetries
          topP
          description
          isEnabled
          createdAt
          createdBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_AGENT_CONFIGURATION = gql`
  query AgentConfiguration($params: FindAgentConfigurationInput!) {
    agentConfiguration(params: $params) {
      success
      message
      errors
      data {
        id
        agentKey
        provider
        modelName
        temperature
        maxTokens
        maxOutputTokens
        maxRetries
        topP
        description
        isEnabled
        createdAt
        createdBy
      }
    }
  }
`;
